<template>
  <div>
    <img src="@/assets/img/bj_2.png" class="bjImg" alt="">
    <div class="boxCont">
      <div class="boxCont_left">
        <div class="boxCont_left_1 animate__animated animation_title">
          汰汰清单
        </div>
        <div class="boxCont_left_1 boxCont_left_1_1 animate__animated animation_title">
          一款简洁高效的<br>日常记录和便签应用
        </div>
        <div class="boxCont_left_2 animate__animated animation_title">
          帮助用户管理日常事务、记录重要事项、提醒待办事项、提高工作和<br>生活效率。无论是个人待办事项的管理，还是随时记录灵感和想法，<br>汰汰清单都能提供便捷的解决方案。
        </div>
        <div class="boxCont_left_3">
          <div class="boxCont_left_3_one animate__animated animation_title" @click="eliminationListDetails">项目介绍
          </div>
          <div class="boxCont_left_3_two animate__animated animation_title" @click="downloadApp">下载APP</div>
        </div>
      </div>
      <div class="boxCont_right_one animate__animated animation_title">
        <div class="boxCont_right_one_cont elementHover" @click="eliminationListDetails">
          <div class="boxCont_right_one_1">日常事务管理</div>
          <img src="@/assets/img/t_1.png" class="boxCont_right_one_2" alt="">
        </div>
      </div>
      <div class="boxCont_right_two">
        <div class="boxCont_right_two_1">
          <div class="boxCont_right_two_1_one animate__animated animation_title">
            <div class="boxCont_right_two_1_one_cont elementHover" @click="eliminationListDetails">
              <img src="@/assets/img/t_2.png" class="boxCont_right_two_1_one_1" alt="">
            </div>
          </div>
          <div class="boxCont_right_two_1_two animate__animated animation_title">
            <div class="boxCont_right_two_1_two_cont elementHover" @click="eliminationListDetails">
              <div class="boxCont_right_two_1_two_1">小助手</div>
              <img src="@/assets/img/t_3.png" class="boxCont_right_two_1_two_2" alt="">
            </div>
          </div>
        </div>
        <div class="boxCont_right_two_2 animate__animated animation_title">
          <div class="boxCont_right_two_2_cont elementHover" @click="eliminationListDetails">
            <div class="boxCont_right_two_2_one">
              <span>不遗漏</span><br>
              重要事务
            </div>
            <img src="@/assets/img/t_4.png" class="boxCont_right_two_2_two" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // Created by www.xingnuocn.com
  // @title: 汰汰清单
  // @author: 刘嘉鑫
  export default {
    data() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      // 项目介绍
      eliminationListDetails() {
        this.$router.push({
          path: "eliminationListDetails",
        });
      },
      // 下载App
      downloadApp() {
        this.$router.push({
          path: "downloadApp",
        });
      },
    }
  }
</script>

<style scoped lang="scss">
  .downToUp {
    animation-name: slideInUp !important;
  }

  @keyframes slideInUp {
    from {
      -webkit-transform: translate3d(0, 14%, 0);
      transform: translate3d(0, 14%, 0);
      visibility: visible;
    }

    to {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }


  .bjImg {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .boxCont {
    position: relative;
    z-index: 99;
    display: flex;
    justify-content: space-between;
    padding: 200px 160px 0;
  }

  .boxCont_left {

    /* width: 34%; */
    .boxCont_left_1 {
      font-weight: 700;
      font-size: 54px;
      color: #2A303A;
      line-height: 76px;
      margin-bottom: 2px;
      letter-spacing: 6px;
    }

    .boxCont_left_1_1 {
      color: #333A47;
      margin-bottom: 51px;
    }

    .boxCont_left_2 {
      font-weight: 400;
      font-size: 17px;
      color: #5D6574;
      line-height: 30px;
      margin-bottom: 70px;
      letter-spacing: 2px;
    }

    .boxCont_left_3 {
      display: flex;
      align-items: center;

      >div {
        border-radius: 66px;
        margin-right: 30px;
        padding: 13px 30px;
        font-weight: 700;
        font-size: 17px;
        cursor: pointer;
      }

      .boxCont_left_3_one {
        color: #FFFFFF;
        background: #0057FE;
      }

      .boxCont_left_3_two {
        background: #FFFFFF;
        color: #0057FE;
      }
    }
  }

  .boxCont_right_one {
    margin-left: auto;
    margin-right: 30px;

    .boxCont_right_one_cont {
      background: #FFFFFF;
      border-radius: 32px;
      padding: 30px 40px 40px;
    }

    .boxCont_right_one_1 {
      font-weight: 700;
      font-size: 30px;
      color: #333A47;
      margin-bottom: 40px;
      letter-spacing: 3px;
    }

    .boxCont_right_one_2 {
      width: 280px;
      height: 340px;
    }
  }

  .boxCont_right_two {
    .boxCont_right_two_1 {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 30px;
      margin-bottom: 30px;

      .boxCont_right_two_1_one {

        .boxCont_right_two_1_one_cont {
          background: #FFFFFF;
          border-radius: 32px;
          padding: 29px 28px 28px 29px;
        }

        .boxCont_right_two_1_one_1 {
          width: 128px;
          height: 128px;
        }
      }

      .boxCont_right_two_1_two {


        .boxCont_right_two_1_two_cont {
          background: linear-gradient(180deg, #0057FE 0%, #FFFFFF 100%);
          border-radius: 32px;
          padding: 30px 43px 0;
          height: 84%;
        }

        .boxCont_right_two_1_two_1 {
          font-weight: 700;
          font-size: 30px;
          color: #FFFFFF;
          margin-bottom: 18px;
          letter-spacing: 3px;
        }

        .boxCont_right_two_1_two_2 {
          width: 90px;
          height: 72px;
        }
      }
    }

    .boxCont_right_two_2 {


      .boxCont_right_two_2_cont {
        background: #FFFFFF;
        border-radius: 32px;
        padding: 34px 40px 46px;
        display: flex;
      }

      .boxCont_right_two_2_one {
        font-weight: 700;
        font-size: 30px;
        color: #333A47;
        line-height: 42px;
        letter-spacing: 3px;

        span {
          color: #0057FE;
        }
      }

      .boxCont_right_two_2_two {
        margin-top: 14px;
        width: 169px;
        height: 180px;
      }
    }
  }
</style>